import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-currency-dropdown',
    templateUrl: './currency-dropdown.component.html',
    styleUrls: ['./currency-dropdown.component.css'],
    standalone: false
})
export class CurrencyDropdownComponent {
  @Input() currencyList: any[] = [];
  @Input() currency: string | null = null;
  @Input() placeholder: string = 'All';
  @Output() currencyChange = new EventEmitter<string | null>();
  @Output() currencyChanged = new EventEmitter<void>();


  onCurrencyChange(value: string | null): void {
    this.currencyChange.emit(value);
    this.currencyChanged.emit();
  }

  trackByIsoCode(index: number, item: { isoCode: string }) {
    return item.isoCode;
  }
}
